import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import Loading from "../../components/loading";
import ModalViewBonos from "./modals/modalViewBonos";
import ModalSearchBonos from "./modals/modalSearchBonos";
//SERVICES  
import OperationService from "../../services/operationService";
import ListService from "../../services/listService";


function ReportOperationBonos() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const initialized = useRef(false)
    const [listOperations, setListOperations] = useState([])
    const [listOperationLinks, setListOperationLinks] = useState([])
    const [listOperationMeta, setListOperationMeta] = useState([])
    const [listUsers, setListUsers] = useState([])
    const [listStatus, setListStatus] = useState([])
    const [modalViewOpen, setModalViewOpen] = useState(false);
    const [bonoSelected, setBonoSelected] = useState('');
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    const [modalSearchOpen, setModalSearchOpen] = useState(false);

    // Search Form
    let defaultDate = new Date().toISOString().slice(0,10);
    const [searchModel, setSearchModel] = useState({
        account: '',
        status: '',
        dateFrom: defaultDate,
        dateTo: defaultDate,
        user: '',
    })

    useEffect(() => {
        if (!initialized.current) {
            //SI ES SORIA SOLO MUESTRA LA CUENTA DE SORIA
            // if(userProfile.id === 29){ searchModel.manager = 29 }
            initialized.current = true
            doSearch()
        }
    }, [false]);

    const doSearch = async (event) => {
        try {  
            setLoading(true)
            const response = await OperationService.getOperationSearch(searchModel)
            setListOperations(response.data)
            setListOperationLinks(response.links)
            setListOperationMeta(response.meta)
            // Users
            const responseUsers = await ListService.getUsersList()
            setListUsers(responseUsers.data)
            // Status
            const responseStatus = await ListService.getStatusList()
            setListStatus(responseStatus.data)
            
        } catch (err) {
            if(err.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: err.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        } finally{ setLoading(false) }
    }
    
    const doExport = async () => {
        var filters = '';
        if(searchModel.dateFrom != '' && searchModel.dateFrom != ""){ filters += '&filter[from]='+searchModel.dateFrom; }
        if(searchModel.dateTo != '' && searchModel.dateTo != ""){ filters += '&filter[to]='+searchModel.dateTo; }
        if(searchModel.account != '' && searchModel.account != null){ filters += '&filter[account]='+searchModel.account; }
        if(searchModel.user != '' && searchModel.user != null){ filters += '&filter[user]='+searchModel.user; }
        if(searchModel.status != '' && searchModel.status != null){ filters += '&filter[state]='+searchModel.status; }
        window.open(process.env.REACT_APP_API_URL+"operations/download/excel?token="+userProfile.token+filters, '_blank')

    }

    const doView = async (obj) => {
        if(obj !== null){
            setBonoSelected(obj)
            setModalViewOpen(true)
        }
    }

    const doPagination = async () => {
        try {  
            setLoading(true)
            const response = await OperationService.getOperationsSearchPagination(listOperationLinks.next)
            response.data.forEach( data => listOperations.push(data) )
            setListOperationLinks(response.links)
            setListOperationMeta(response.meta)
        } catch (err) {
            if(err.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: err.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        } finally{ setLoading(false) }
    }

    const doOpenModalSeacht = async () => {
        setModalSearchOpen(true)
    }

    if(loading){
        return(
            <Loading></Loading>
        )
    }


    return (
        <>
            <div className="row">
                <div className="col">
                    <h2>Reporte Operaciones de Mercado { listOperationMeta.total > 0 && <span className="fontMedium">({listOperationMeta.total})</span> }</h2>
                </div>
                <div className="col">
                    <div className="btn-group float-end" role="group" aria-label="First group">
                        <button type="button" className="btn btn-outline-secondary" title="Exportar" onClick={doExport}>
                            <i className="tf-icons bx bx-export" />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" title="Buscar" onClick={doOpenModalSeacht } >
                            <i className="tf-icons bx bx-filter" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* <Sheet sx={{ height: 580, overflow: 'auto', backgroundColor: 'transparent', padding: '2px' }} className="table-responsive"> */}
                    <table className="table table-striped table-hover" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Comintente</th>
                                <th>Mercado</th>
                                <th>Precio</th>
                                <th>Tipo Operación</th>
                                {/* <th>Plazo</th> */}
                                <th>Especie</th>
                                <th>Valor Nominal</th>
                                <th>Monto</th>
                                <th>Usuario</th>
                                <th>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            {listOperations.map(operation => {
                                return (
                                    <tr key={operation.id}>  
                                        <td className="small">{operation.id}</td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {moment(operation.date).format('DD/MM/YYYY')}
                                                        </span>
                                                    </a>
                                                    <small className="text-muted">{moment(operation.date).format('HH:mm')}</small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {operation.account.name.length > 30 ?
                                                                `${operation.account.name.substring(0, 30)}...` : operation.account.name
                                                            }
                                                        </span>
                                                    </a>
                                                    <small className="text-muted"><span className="badge bg-label-dark">{operation.account.account}</span></small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">{operation.market.name}</span>
                                                    </a>
                                                    <small className="text-muted">
                                                        {operation.segment_id === 1 && <span className="badge bg-label-primary me-1">{operation.segment.name}</span>}
                                                        {operation.segment_id === 2 && <span className="badge bg-label-info me-1">{operation.segment.name}</span>}
                                                        {operation.segment_id === 3 && <span className="badge bg-label-secondary me-1">{operation.segment.name}</span>}
                                                    </small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{operation.price_type.name}</td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        {operation.operation_type_id === 1 && <span className="badge bg-label-success me-1">{operation.operation_type.name}</span>}
                                                        {operation.operation_type_id === 2 && <span className="badge bg-label-danger me-1">{operation.operation_type.name}</span>}
                                                    </a>
                                                    <small className="text-muted"><span className="badge bg-label-dark">{operation.settlement_term.name}</span></small>
                                                </div>
                                            </div>
                                        </td>
                                        {/* <td>
                                            {operation.operation_type_id === 1 && <span className="badge bg-label-success me-1">{operation.operation_type.name}</span>}
                                            {operation.operation_type_id === 2 && <span className="badge bg-label-danger me-1">{operation.operation_type.name}</span>}
                                        </td>
                                        <td>{operation.settlement_term.name}</td> */}
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">{operation.ticker}</span>
                                                    </a>
                                                    <small className="text-muted"><span className="badge bg-label-dark">{operation.currency.name}</span></small>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.qty} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                            /> 
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.total} 
                                                decimalScale={5} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                                prefix={'$'}  
                                            /> 
                                        </td>
                                        <td className="small">{operation.user.full_name}</td>
                                        <td>
                                            {operation.operation_state_id === 1 && <span className="badge bg-label-secondary me-1">{operation.operation_state.display_name}</span>}
                                            {operation.operation_state_id === 2 && <span className="badge bg-label-warning me-1">{operation.operation_state.display_name}</span>}
                                            {operation.operation_state_id === 3 && <span className="badge bg-label-success me-1">{operation.operation_state.display_name}</span>}
                                            {operation.operation_state_id === 4 && <span className="badge bg-label-danger me-1">{operation.operation_state.display_name}</span>}
                                        </td>
                                        <td className="text-end">
                                            <div className="dropdown">
                                                <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                                    <i className="bx bx-dots-vertical-rounded" />
                                                </button>
                                                <div className="dropdown-menu">
                                                    <a className="dropdown-item" href="#"  onClick={() => {  doView(operation) } }>
                                                        <i className="bx bx-eyes me-1" /> Ver
                                                    </a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                {/* </Sheet> */}
            </div>

            { listOperationLinks.next !== null ?
                    <div className="row mt-4">
                        <div className="col d-grid gap-2 d-md-flex justify-content-md-center">
                        { sending ? 
                            <div className="d-flex justify-content-center">
                                <div className="spinner-border text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        : 
                            <button type="button" className="btn btn-outline-info" onClick={doPagination}>Mas Información</button>
                        }
                        </div>
                    </div>
                :
                    null
            }
            
            {/* SEARCH */}
            <ModalSearchBonos 
                handleOpen={setModalSearchOpen} 
                isOpen={modalSearchOpen} 
                setSearch={setSearchModel}
                search={searchModel}
                doSearch={doSearch}
                listStatus={listStatus}
                listUsers={listUsers}
            />
            
            { bonoSelected !== '' ?
                <ModalViewBonos 
                    handleOpen={setModalViewOpen} 
                    isOpen={modalViewOpen} 
                    selected={bonoSelected}
                    fundId={bonoSelected.id}
                />
            :
                null
            }

        </>
     );

}

export default ReportOperationBonos;